// @flow

import type { AnyAction } from 'react-redux';
import { combineReducers } from 'redux';
import type { Reducer } from 'redux';

import type { State } from '../../types';
import marketplaceReducer from '../marketplace/reducers';

import resultsReducer from './results';
import searchReducer from './search';

export default (combineReducers({
  search: searchReducer,
  results: resultsReducer,
  marketplace: marketplaceReducer,
}): Reducer<State, AnyAction>);
